import React from 'react';
import classNames from 'classnames';
import styles from './SliderArrows.scss';

export function PrevArrow(props) {
    const {onClick, customClassname} = props;
    return (
        <button
            className={classNames(styles.arrow, styles.prevArrow, customClassname)}
            onClick={onClick}
        />
    );
}

export function NextArrow(props) {
    const {onClick, customClassname} = props;
    return (
        <button
            className={classNames(styles.arrow, styles.nextArrow, customClassname)}
            onClick={onClick}
        />
    );
}


// WEBPACK FOOTER //
// ./src/components/controls/SliderArrows.jsx